var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    [
      _c(
        "DefaultContentLayout",
        {
          scopedSlots: _vm._u([
            {
              key: "right-side",
              fn: function () {
                return [
                  _c("JobBoardApplicationsFilters", {
                    attrs: {
                      currentUserId: _vm.currentUser.id,
                      filters: _vm.filters,
                    },
                    on: {
                      filtersChanged: _vm.updateFilters,
                      resetFilters: _vm.resetFilters,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "LoadingOverlay",
            { attrs: { hasData: !!_vm.applications, loading: _vm.isLoading } },
            [
              !_vm.isApplicationsExist
                ? _c("EmptyListPlaceholder", {
                    attrs: {
                      title: _vm.emptyListMessage,
                      subtitle: _vm.emptyListSubtitle,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "image",
                          fn: function () {
                            return [_c("EmptyListImageApplications")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2068000470
                    ),
                  })
                : [
                    _vm._l(_vm.applications, function (application) {
                      return _c("JobBoardApplicationCard", {
                        key: application.id,
                        attrs: {
                          currentUserId: _vm.currentUser.id,
                          currentUserRole: _vm.currentUser.role,
                          note: application.note,
                          applicationId: application.id,
                          jobTitle: application.posting.job_title,
                          interviewedBy: application.interviewed_by,
                          interviewer: application.interviewer,
                          companyName:
                            application.posting.company.business_name,
                          postingCompanyId: application.posting.company.id,
                          duration: application.posting.duration,
                          employmentType: application.posting.employment_type,
                          isCancelled: application.is_cancelled,
                          skills: application.posting.skills,
                          createdAt: application.posting.created_at,
                          location: _vm.getPostingLocation(application.posting),
                          description: application.posting.description,
                          postingId: application.posting.id,
                          postingActive: application.posting.active,
                          industries: application.posting.industries,
                          attachedDocument: application.document,
                        },
                        on: {
                          applicationNoteUpdated: _vm.refetchApplications,
                          refetchAfterDeletingApplication:
                            _vm.refetchApplications,
                          detachDocument: _vm.detachDocument,
                          removeComments: _vm.removeComments,
                        },
                      })
                    }),
                    _c("CardPagination", {
                      attrs: { config: _vm.paginationConfig },
                      on: {
                        "update:config": function ($event) {
                          _vm.paginationConfig = $event
                        },
                      },
                    }),
                  ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }